import { useSyncExternalStore } from 'react';

const storageKey = 'crm4chef.personal-report-delivery.unconfirmed';
const pending = new Set<symbol>();
const listeners = new Set<() => void>();
let unknown = false;
type PersonalReportDeliveryResult = 'accepted' | 'delivered' | 'failed' | 'rejected' | 'document-failed';
let result: PersonalReportDeliveryResult | '' = '';
let storageUnavailable = false;
try {
  const stored = sessionStorage.getItem(storageKey);
  if (stored === 'accepted' || stored === 'delivered' || stored === 'failed' || stored === 'rejected' ||
      stored === 'document-failed') result = stored;
  else unknown = stored !== null;
} catch {
  storageUnavailable = true;
}

const notify = () => listeners.forEach(listener => listener());
const snapshot = () => storageUnavailable ? 'storage-unavailable'
  : pending.size ? 'pending' : unknown ? 'unknown' : result;
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

export const usePersonalReportDeliveryActivity = () => useSyncExternalStore(subscribe, snapshot);

export const beginPersonalReportDelivery = () => {
  sessionStorage.setItem(storageKey, '1');
  const id = Symbol();
  pending.add(id);
  notify();
  return id;
};

export const finishPersonalReportDelivery = (
  id: symbol, uncertain: boolean, knownResult: PersonalReportDeliveryResult = 'rejected',
) => {
  pending.delete(id);
  unknown ||= uncertain;
  if (!uncertain) result = knownResult;
  try {
    sessionStorage.setItem(storageKey, pending.size || unknown ? '1' : result);
  } catch {
    storageUnavailable = true;
  }
  notify();
};

export const acknowledgeUnknownPersonalReportDelivery = () => {
  if (pending.size) return;
  sessionStorage.removeItem(storageKey);
  storageUnavailable = false;
  unknown = false;
  result = '';
  notify();
};
